module.exports = __webpack_public_path__ + "img/PlayButtonNew.f9ebb4f3.png";